import { Injectable }    from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable }    from 'rxjs';

export interface CanComponentDeactivate {
 canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
  canDeactivate(component: CanComponentDeactivate) {

    if(component.canDeactivate){
      return component.canDeactivate();
    }
    else {
      const obs = Observable.create(function(observer){
        observer.next(true);
        observer.complete();
      });
      return obs;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/_guards/can-deactivate.guard.ts